import { connect } from 'react-redux';
import ParameterJP from '../../views/Settings/ParameterJP.view';
import {
  getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
  getPrmStaffKepsek, getParamOptionsAcademics
} from '../../states/thunks/options.thunk';
import { listBlockUnits, editParameterJP, saveParameterJP, listParameterJP } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getPrmStaffKepsekOptions: payload => dispatch(getPrmStaffKepsek(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListParameterJP: (payload, goback) => dispatch(listParameterJP(payload, goback)),
    handleSaveParameterJP: (payload, goback) => dispatch(saveParameterJP(payload, goback)),
    handleEditParameterJP: (payload, goback) => dispatch(editParameterJP(payload, goback)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ParameterJP);
